import { useQuery } from '@tanstack/react-query';
import { searchApi } from '@/apis/search';
import { QUERY_KEYS } from '@/constants';

/** Mirrors the backend's own floor — a single character matches almost everything. */
export const MIN_SEARCH_LENGTH = 2;

export const useGlobalSearch = (query: string) =>
  useQuery({
    queryKey: [QUERY_KEYS.SEARCH, query],
    queryFn: () => searchApi.global(query),
    enabled: query.trim().length >= MIN_SEARCH_LENGTH,
    staleTime: 30 * 1000,
  });
